import { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { BarChart2, Building2, ClipboardList, LayoutGrid, LogOut, Menu, Settings2, ShieldCheck, UserCheck, X } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import "@/App.css";

const NAV = [
  { to: "/padma", label: "Portal PADMA", icon: LayoutGrid },
  { to: "/kipk", end: true, label: "Pusat Kendali Masalah KIPK", icon: BarChart2, masterOnly: true },
  { to: "/kipk/manajemen-akun", label: "Manajemen Akun", icon: Settings2 },
  { to: "/kipk/manajemen-pt", label: "Manajemen PT", icon: UserCheck },
  { to: "/kipk/manajemen-task", label: "Manajemen Task", icon: ClipboardList },
  { to: "/kipk/rekap-pt", label: "Rekapitulasi PT", icon: Building2 },
];

export default function KipkLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const doLogout = async () => { await logout(); navigate("/login", { replace: true }); };

  return (
    <div className={`app-shell ${open ? "sidebar-open" : ""}`}>
      {open && <div className="sidebar-backdrop" data-testid="kipk-sidebar-backdrop" onClick={() => setOpen(false)} />}
      <aside className="sidebar" data-testid="kipk-sidebar">
        <div className="brand-mark">
          <Link to="/padma" className="brand-icon brand-logo padma-home-link" aria-label="Kembali ke Akses Layanan PADMA" title="Akses Layanan PADMA" data-testid="kipk-sidebar-padma-home-link" onClick={() => setOpen(false)}><img src="/logo-padma-transparent.png" alt="Logo PADMA" data-testid="kipk-sidebar-padma-logo" /></Link>
          <div><strong>KIPK LLDIKTI VII</strong><span>OPERATIONS DESK</span></div>
          <button className="sidebar-close" data-testid="kipk-sidebar-close" onClick={() => setOpen(false)} aria-label="Tutup menu"><X size={18} /></button>
        </div>
        <nav>
          <div className="nav-caption">HALAMAN</div>
          {NAV.filter((n) => !n.masterOnly || user?.role === "master").map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.to.split("/").pop() || "kipk"}`}
              className={({ isActive }) => `nav-item ${isActive ? "nav-active" : ""}`} onClick={() => setOpen(false)}>
              <n.icon size={16} />
              <div className="nav-item-body"><span>{n.label}</span></div>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="acct-me">
            <ShieldCheck size={14} />
            <div>
              <strong data-testid="me-display-name">{user?.display_name}</strong>
              <small data-testid="me-role">Peran: {user?.role === "master" ? "Super Admin" : "Admin"}</small>
            </div>
          </div>
          <button className="download-button ghost logout-btn" data-testid="kipk-logout" onClick={doLogout}><LogOut size={14} /> Keluar</button>
        </div>
      </aside>
      <main className="main-content">
        <header className="topbar mobile-only-topbar">
          <button className="icon-button menu-button" data-testid="kipk-sidebar-open" aria-label="Buka menu" onClick={() => setOpen(true)}><Menu size={18} /></button>
        </header>
        <Outlet />
      </main>
    </div>
  );
}
